import React, { useEffect, useState } from 'react';
import './incident.css';
import axios from 'axios';
import { showSuccessToast, showErrorToast } from '../toast-utils';
import { incident_url } from '../apis';

function Incident(props) {
  const [falsePositive, setFalsePositive] = useState(props.selectedIncident?.false_positive || false);
  const [remarks, setRemarks] = useState(props.selectedIncident?.remarks || '');

  const getCurrentUserToken = () => {
    const currentUser = JSON.parse(localStorage.getItem('currentUser') || '{}');
    return currentUser.token || '';
  }

  var userToken = getCurrentUserToken();
  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${userToken}`
  }

  useEffect(() => {
    if (props.selectedIncident) {
      setFalsePositive(props.selectedIncident.false_positive);
      setRemarks(props.selectedIncident.remarks);
    }
  }, [props.selectedIncident]);

  const handleFalsePositiveChange = (event) => {
    setFalsePositive(event.target.value);
  };

  const handleRemarksChange = (event) => {
    setRemarks(event.target.value);
  };

  const updateData = async (event) => {
    event.preventDefault();
    const apiBody = {
      remarks: remarks,
      tenant_id: JSON.parse(localStorage.getItem('currentUser') || '').tenant_id,
      session_id: props.selectedIncident.id.toString(),
      false_positive: falsePositive,
    }
    try {
      await axios.put(incident_url, apiBody, { headers });
      showSuccessToast('Details updated successfully');
    } catch (error) {
      if (error.response && error.response.data.msg === "Token has expired") {
        props.onLogout('token');
      } else {
        showErrorToast('Error occurred');
      }
    }
  }

  if (!props.selectedIncident) {
    return <div className="main_inc d-flex flex-column justify-content-evenly">
      <div className="body">
        <table>
          <tbody>
            <tr>
              <td className="name">Date and Time of Incident</td>
              <td>:</td>
            </tr>
            <tr>
              <td className="name">Description</td>
              <td>:</td>
            </tr>
            <tr>
              <td className="name">Session Id</td>
              <td >:</td>
            </tr>
            <tr>
              <td className="name">User Id</td>
              <td>:</td>
            </tr>
            <tr>
              <td className="name">Channel Source</td>
              <td>:</td>
            </tr>
            <tr>
              <td className="name">Source OS</td>
              <td>:</td>
            </tr>
            <tr>
              <td className="name">User Location</td>
              <td>:</td>
            </tr>
            <tr>
              <td className="name">Risk Level</td>
              <td>:</td>
            </tr>
            <tr>
              <td className="name">Risk Score(%)</td>
              <td>:</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="updatable d-flex flex-column">
        <form >
          <div className="container_inc d-flex flex-row align-items-center justify-content-start">
            <label>False Positive</label>
            <select className='options'>
              <option value="Yes">Yes</option>
              <option value="No">No</option>
            </select>
          </div>
          <div className="container_inc d-flex flex-row align-items-center justify-content-start ">
            <label>Remarks</label>
            <textarea className='field1'></textarea>
          </div>
          <br />
          <div className="submit-div d-flex flex-row justify-content-center ">
            <button className="btn btn-primary" type="submit">
              Update
            </button>
          </div>
        </form>
      </div>
    </div>;
  }

  return (
    <div className="main_inc d-flex flex-column justify-content-evenly">
      <div className="body">
        <table>
          <tbody>
            <tr>
              <td className="name">Date and Time of Incident</td>
              <td>:</td>
              <td className="value">
                {new Date(props.selectedIncident.date).toLocaleString('en-US', {
                  year: 'numeric',
                  month: 'short',
                  day: 'numeric',
                  hour: 'numeric',
                  minute: 'numeric',
                  second: 'numeric',
                  hour12: true,
                  timeZone: 'Asia/Kolkata',
                })}</td>
            </tr>
            <tr>
              <td className="name">Description</td>
              <td>:</td>
              <td className="value">
                Account Takeover (ATO) attack during {props.selectedIncident.channel_source} App Login Phase
              </td>
            </tr>
            <tr>
              <td className="name">Session Id</td>
              <td>:</td>
              <td className="value">{props.selectedIncident.id}</td>
            </tr>
            <tr>
              <td className="name">User Id</td>
              <td>:</td>
              <td className="value">{props.selectedIncident.user_name}</td>
            </tr>
            <tr>
              <td className="name">Channel Source</td>
              <td>:</td>
              <td className="value">{props.selectedIncident.channel_source}</td>
            </tr>
            <tr>
              <td className="name">Source OS</td>
              <td>:</td>
              <td className="value">{props.selectedIncident.user_source_os}</td>
            </tr>
            <tr>
              <td className="name">User Location</td>
              <td>:</td>
              <td className="value">{props.selectedIncident.user_location}</td>
            </tr>
            <tr>
              <td className="name">Risk Level</td>
              <td>:</td>
              <td className="value">{props.selectedIncident.risk_level}</td>
            </tr>
            <tr>
              <td className="name">Risk Score(%)</td>
              <td>:</td>
              <td className="value">{props.selectedIncident.request_risk_score}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="updatable d-flex flex-column">
        <form onSubmit={updateData} >
          <div className="container_inc d-flex flex-row align-items-center justify-content-start">
            <label>False Positive</label>
            <select className='options' value={falsePositive} onChange={handleFalsePositiveChange}>
              <option value="Yes">Yes</option>
              <option value="No">No</option>
            </select>
          </div>
          <div className="container_inc d-flex flex-row align-items-center justify-content-start">
            <label>Remarks</label>
            <textarea className='field1' value={props.selectedIncident ? remarks : ''} onChange={handleRemarksChange}></textarea>
          </div>
          <br />
          <div className="submit-div d-flex flex-row justify-content-center ">
            <button className="btn btn-primary" type="submit">
              Update
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default Incident;
